// Submit Module  All Action type
export const SAVE_MODULE_MASTER = "SAVE_MODULE_MASTER"
export const SAVE_MODULE_MASTER_SUCCESS = 'SAVE_MODULE_MASTER_SUCCESS'
export const POST_MODULES_SUBMIT_ERROR = 'POST_MODULES_SUBMIT_ERROR'

// Fetch Module_List  All Action type 
export const FETCH_MODULES_LIST = "FETCH_MODULES_LIST"
export const FETCH_MODULES_LIST_SUCCESS = 'FETCH_MODULES_LIST_SUCCESS'
export const FETCH_MODULES_LIST_ERROR = 'FETCH_MODULES_LIST_ERROR'

// Fetch Module_List  All Action type 
export const DELETE_MODULE_ID = "DELETE_MODULE_ID"
export const DELETE_MODULE_ID_SUCCESS = 'DELETE_MODULE_ID_SUCCESS'
export const DELETE_MODULE_ID_ERROR = 'DELETE_MODULE_ID_ERROR'

export const EDIT_MODULE_ID = "EDIT_MODULE_ID"
export const EDIT_MODULE_ID_SUCCESS = 'EDIT_MODULE_ID_SUCCESS'

export const UPDATE_MODULE_ID = "UPDATE_MODULE_ID"
export const UPDATE_MODULE_ID_SUCCESS = 'UPDATE_MODULE_ID_SUCCESS'


export const MODULE_API_ERROR_ACTION = 'MODULE_API_ERROR_ACTION'

